'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPublicVisitorContext = fetchPublicVisitorContext;

var _noAuthApiClient = require('../utils/http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _envInfo = require('../constants/envInfo');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var envSuffix = _envInfo.isProd ? '' : 'qa';
var HOST = 'https://t.hs-growth-metrics' + envSuffix + '.com';
var BASE_PATH = 'reporting/v1';

function fetchPublicVisitorContext(utk) {
  return _noAuthApiClient2.default.get(HOST + '/' + BASE_PATH + '/context/utk', {
    query: { utk: utk }
  });
}